module.exports = __webpack_public_path__ + "static/img/vip.12d52061.png";